(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
 class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.header = document.querySelector('.section-header');
    if (!this.header) return;
    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};
    this.setHeaderHeight();
    window
      .matchMedia('(max-width: 990px)')
      .addEventListener('change', this.setHeaderHeight.bind(this));
    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }
    this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => {
      this.preventReveal = true;
    };
    this.addEventListener(
      'preventHeaderReveal',
      this.hideHeaderOnScrollUp
    );
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.createObserver();
  }
  setHeaderHeight() {
    if (!this.header) return;

    document.documentElement.style.setProperty(
      '--header-height',
      `${this.header.offsetHeight}px`
    );
  }
  disconnectedCallback() {
    this.removeEventListener(
      'preventHeaderReveal',
      this.hideHeaderOnScrollUp
    );
    window.removeEventListener('scroll', this.onScrollHandler);
  }
  createObserver() {
    const observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;

      observer.disconnect();
      requestAnimationFrame(() => {
        this.onScroll();
      });
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop =
      window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    if (
      scrollTop > this.headerBounds.bottom &&
      scrollTop > this.headerBounds.top
    ) {
      this.header.classList.add('scrolled-past-header');
    } else {
      this.header.classList.remove('scrolled-past-header');
    }

    /*
     * Existing sticky header behavior
     */
    if (
      scrollTop > this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      this.header.classList.add('scrolled-past-header');

      if (this.preventHide) return;

      requestAnimationFrame(this.hide.bind(this));
    } else if (
      scrollTop < this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      this.header.classList.add('scrolled-past-header');

      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');

      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;

    this.header.classList.add(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky'
    );

    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;

    this.header.classList.add(
      'shopify-section-header-sticky',
      'animate'
    );

    this.header.classList.remove(
      'shopify-section-header-hidden'
    );
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;

    this.header.classList.remove(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
      'animate'
    );
  }

  closeMenuDisclosure() {
    this.disclosures =
      this.disclosures ||
      this.header.querySelectorAll('header-menu');

    this.disclosures.forEach((disclosure) => {
      disclosure.close();
    });
  }

  closeSearchModal() {
    this.searchModal =
      this.searchModal ||
      this.header.querySelector('details-modal');

    if (this.searchModal) {
      this.searchModal.close(false);
    }
  }
}
customElements.define('sticky-header', StickyHeader);
const tabs = document.querySelectorAll('.mega-menu__item');
const contents = document.querySelectorAll('.mega-menu__submenu');

function activateTab(index) {
  tabs.forEach((tab) => {
    tab.classList.remove('active');
  });

  contents.forEach((content) => {
    content.classList.remove('active');
  });

  if (tabs[index]) {
    tabs[index].classList.add('active');
  }

  if (contents[index]) {
    contents[index].classList.add('active');
  }
}
if (tabs.length && contents.length) {
  activateTab(0);
}
tabs.forEach((tab, index) => {
  tab.addEventListener('mouseenter', function () {
    activateTab(index);
  });

  tab.addEventListener('click', function () {
    activateTab(index);
  });
});
const buttons = document.querySelectorAll('.header__menu-plus');
const megaMenus = document.querySelectorAll('.header-mega-menu');
const closeIcons = document.querySelectorAll('.submenu-icon-close');
buttons.forEach((button, index) => {
  button.addEventListener('click', function (event) {
    event.preventDefault();

    if (!megaMenus[index]) return;

    megaMenus[index].classList.toggle('active');
  });
});
closeIcons.forEach((closeIcon, index) => {
  closeIcon.addEventListener('click', function () {
    if (!megaMenus[index]) return;

    megaMenus[index].classList.remove('active');
  });
});
tabs.forEach((tab, index) => {
  tab.addEventListener('click', function () {
    activateTab(index);

    megaMenus.forEach((menu, menuIndex) => {
      if (menuIndex !== index) {
        menu.classList.remove('active');
      }
    });
  });
});




  } catch(e) { console.error(e); }
})();
})();
